'use client';
import { Button } from '@ai-business-os/ui/button';
export default function ErrorPage({
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <main className="form-page">
      <section className="form-card" role="alert">
        <h1>İşlem tamamlanamadı</h1>
        <p className="muted">Geçici bir bağlantı sorunu olabilir. Lütfen yeniden deneyin.</p>
        <Button onClick={reset}>Yeniden dene</Button>
        <a href="/" className="button button--secondary">
          Ana sayfa
        </a>
      </section>
    </main>
  );
}
